import type {EagColumnState} from '../../types/EagColumnState';
import {useEagGridSelector} from '../useEagGridSelector';
import {selectOrderedVisibleColumns} from './selectOrderedVisibleColumns';

export function useOrderedVisibleColumns(): EagColumnState[] {
  return useEagGridSelector(selectOrderedVisibleColumns);
}
